export default __webpack_public_path__ + "static/media/chevron-left-disabled.5cf15e12.svg";